export const defaultState = {
	name: '',
	account: '',
};
